import axios from "@axios";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((logs) => ({
        data: logs.data,
        old_data: logs.old_data,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {

    async getAll({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_LOGS_MS_URL}/v1/logs`, {params});

      if (!data) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    async export(_, params) {
      try {
        const response = await axios.get(`${window.__env.VUE_APP_LOGS_MS_URL}/v1/logs/export`, {
          params,
          responseType: 'arraybuffer', // Ensures binary data
        });

        // Create a Blob from the binary response
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        // Generate download URL
        const url = window.URL.createObjectURL(blob);

        // Create a download link
        const link = document.createElement('a');
        link.href = url;

        // Extract filename from headers or fallback
        const contentDisposition = response.headers['content-disposition'];
        const filename = contentDisposition
          ? contentDisposition.split('filename=')[1].replace(/"/g, '') // Remove quotes if any
          : 'exported-file.xlsx';

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Cleanup the object URL to prevent memory leaks
        window.URL.revokeObjectURL(url);

        // Dispatch notification of success
        const notification = {
          id: filename,
          progress: 100,
          completed: true,
          view: 'Logs',
          url: url,
          download: filename,
          title: 'Reporte de Logs',
          body: 'Descarga completa',
          error: false,
          timestamp: new Date().toLocaleString(),
        };
        store.dispatch('grid/updateDownloadNotification', notification);
      } catch (error) {
        console.error('Error during export:', error);

        // Dispatch notification of error
        const notification = {
          id: 'error-export',
          progress: 0,
          completed: false,
          view: 'Traffic',
          title: 'Error en la exportación',
          body: 'Hubo un error al intentar descargar el archivo.',
          error: true,
          timestamp: new Date().toLocaleString(),
        };
        store.dispatch('grid/updateDownloadNotification', notification);
      }
    },
    async add(_, params) {
      const { data } = await axios.post("v1/logs", params);

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/logs/${id}`, params);

      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/logs/${id}`);

      return data;
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
